import { useRequestStore } from "entities/Request";
import api, { baseApiService } from "shared/api";
import useSWR from "swr";

const LOCK_POOLING_INTERVAL = 1000 * 60 * 4 + 1000 * 30; // * 4.5 minutes

export function useRequestLock(requestId, { triggerRequest = false } = {}) {
  const updateRequest = useRequestStore((state) => state.updateRequest);

  useSWR(
    triggerRequest && requestId
      ? [baseApiService.ENDPOINTS.request.shared.lock, requestId]
      : null,
    ([url, requestId]) =>
      api
        .post(url, {
          application_id: requestId,
        })
        .then((res) => {
          if (res.data?.data) {
            updateRequest({ locks: res.data });
          }
        }),
    {
      revalidateOnFocus: false,
      refreshInterval: LOCK_POOLING_INTERVAL,
    }
  );
}
